import React from 'react';

const Logo = () => {
	return (
		<div className="logo-wrapper">
			<a className='logo' href="/index.html">DeDeLend</a>
		</div>
	);
};

export default Logo;